export const getCurrentCooperationCompany = (state) => state.insuranceCompany.insuranceCompany;
